import React from 'react';
import { Text, View } from 'react-native';
import { Image } from 'expo-image';
import { colors, fontFamily, useAppTheme } from '@/theme';
import { ScaledSheet } from '@/theme/responsive';

interface Props {
  uri?: string | null;
  name: string;
  size?: number;
  ring?: boolean;
}

function initialsOf(name: string) {
  return name
    .trim()
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export function Avatar({ uri, name, size = 44, ring }: Props) {
  const { colors, isDark } = useAppTheme();
  const dim = { width: size, height: size, borderRadius: size / 2 };
  if (uri) {
    return (
      <View style={[dim, ring && [styles.ring, { borderColor: colors.accent }], ring && { padding: 2 }]}>
        <Image source={{ uri }} style={[dim, ring && { width: size - 4, height: size - 4, borderRadius: (size - 4) / 2 }]} contentFit="cover" transition={150} />
      </View>
    );
  }
  return (
    <View style={[dim, styles.fallback, { backgroundColor: isDark ? colors.surfaceMuted : colors.accentSoft }, ring && [styles.ring, { borderColor: colors.accent }]]}>
      <Text style={{ fontFamily: fontFamily.bold, fontSize: size * 0.36, color: isDark ? colors.textPrimary : colors.accent }}>{initialsOf(name) || '?'}</Text>
    </View>
  );
}

const styles = ScaledSheet.create({
  fallback: { backgroundColor: colors.accentSoft, alignItems: 'center', justifyContent: 'center' },
  ring: { borderWidth: 2, borderColor: colors.accent },
});
